import React from 'react';
import logo from '../assets/shared/jet-travel-logo-white.svg'


const PulsatingLogo = () => {
    return <img src={logo} alt="Loading..." className="pulsating-logo" />;
};

export default PulsatingLogo;
